// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import AddressResourceViewModel from '../../../../viewModel/resource/AddressResourceViewModel';
import UserAccountResourceViewModel from '../../../../viewModel/resource/UserAccountResourceViewModel';
import UserAccountResourceDTO from '../../dto/resource/UserAccountResourceDTO';

export default abstract class UserAccountResourceModel extends BaseModel<UserAccountResourceDTO> {
  /**
  * @type {int64}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  */
  get username() { return this.dto.username; }
  set username(value) { this.dto.username = value; }
  /**
  */
  get addresses() { return this.getArrayModels(() => this.dto.addresses, AddressResourceViewModel)!; }
  set addresses(value) { this.setArrayModels(() => this.dto.addresses, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.id = value;
    this.dto.username = qs.username;
  }
}
